import { createCardsStore } from '@/composables/query-param-store/cards-store'

export const CARD_LAYERS_MAIN = 'layers_main'
export const CARD_LAYERS_LEGEND = 'layers_legend'
export const CARD_LAYERS_DETAIL = 'layers_detail'

export const CARD_KEYS = [
  CARD_LAYERS_MAIN,
  CARD_LAYERS_LEGEND,
  CARD_LAYERS_DETAIL,
] as const

export type CardId = (typeof CARD_KEYS)[number]

export const useCardsStore = createCardsStore(CARD_KEYS, {})
